import { render, staticRenderFns } from "./Amend.vue?vue&type=template&id=178a3018"
import script from "./Amend.vue?vue&type=script&lang=js"
export * from "./Amend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports